import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import useGlobalContext from "hooks/globalData";
import{ AutocompleteWithQuery } from "@knowfully/ui.common";
import { AutocompleteWithQueryProps } from "@knowfully/ui.common/components/AutocompleteWithQuery";
import { GenericSkuFilterModel } from "services/organizationPortalClient";
import { Grid } from "@mui/material";

export type SelectDayOfWeekProps = Omit<
  AutocompleteWithQueryProps<GenericSkuFilterModel>,
  "fetchedData" | "failMessage" | "labelField" | "multiple"
>;

export default function SelectDayOfWeek(props: SelectDayOfWeekProps) {
  const { formatMessage: t } = useIntl();
  const { catalogFilterService } = useGlobalContext();

  const data = useQuery(["getDaysOfWeek"], () =>
    catalogFilterService.getDaysOfWeek()
  );

  return (
    <Grid item xs={12} sm={12} md={4}>
      <AutocompleteWithQuery
        {...props}
        size="small"
        labelField="value"
        fetchedData={data}
        label={t({ id: "dayOfWeek" })}
        failMessage={t({ id: "fetchError" })}
      />
    </Grid>
  );
}
